// @flow

import React from 'react';
import { Grid, Form, Button } from 'semantic-ui-react';
import OrderDropdown from 'shared/components/OrderDropdown';
import type { Question } from '../../types';

type Props = {
  question: Question,
  showValidationErrors: boolean,
  questionsCount: number,
  onChangeTitle: (title: string) => void,
  onChangeOrder: (value: number) => void,
  onDelete: () => void,
};

const styles = {
  margin: {
    marginTop: '21px',
  },
};

const QuestionHeader = ({
  question,
  showValidationErrors,
  questionsCount,
  onChangeTitle,
  onChangeOrder,
  onDelete,
}: Props) => {
  const changeTitle = event => onChangeTitle(event.target.value);

  return (
    <Grid>
      <Grid.Column width={14}>
        <Form.Field
          required
          error={showValidationErrors && question.title.length === 0}
        >
          <label>Libellé de la question</label>
          <input
            type="text"
            placeholder="Saisissez le libellé de la question"
            value={question.title}
            onChange={changeTitle}
          />
        </Form.Field>
      </Grid.Column>
      <Grid.Column width={1} textAlign="center" verticalAlign="middle">
        <OrderDropdown
          style={styles.margin}
          value={question.order}
          orderCount={questionsCount}
          onChange={onChangeOrder}
        />
      </Grid.Column>
      <Grid.Column width={1} textAlign="center" verticalAlign="middle">
        <Button
          type="button"
          icon="close"
          color="red"
          onClick={onDelete}
          style={styles.margin}
        />
      </Grid.Column>
    </Grid>
  );
};

export default QuestionHeader;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionHeader.js